<template>
  <button :class="style.cross" />
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "./buttonCross.module.scss";
export default defineComponent({
  data() {
    return {
      style
    };
  }
});
</script>
